<template>
  <el-table class="list" id="listIntercoms" :data="intercoms">
    <el-table-column prop="short_name" label="Название">
      <template slot-scope="scope">
        <router-link class="link" :to="'/intercom/edit/' + scope.row.id_intercom">
          {{ scope.row.short_name || "Нет данных" }}
        </router-link>
      </template>
    </el-table-column>
    <el-table-column prop="address" label="Адрес" />
    <el-table-column prop="uuid" label="UUID" />
    <el-table-column prop="id_sip_config" label="Номер SIP-аккаунта" />
    <el-table-column align="center" prop="apartment_from" label="Начало диапазона" />
    <el-table-column align="center" prop="apartment_to" label="Конец диапазона" />
    <el-table-column align="center" width="120px" v-if="$can('delete', 'intercoms')" label="Действия">
      <template slot-scope="scope">
        <el-button size="small" type="danger" @click="onRemove(scope.row.id_intercom)">
          Удалить <fa :icon="['fas', 'trash-alt']" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { mapActions, mapState } from "vuex";

library.add(faTrashAlt);

export default {
  name: "IntercomsTable",
  components: { fa },
  computed: {
    ...mapState("intercoms", {
      intercoms: (state) => state.data,
    }),
  },
  methods: {
    ...mapActions("intercom", {
      deleteIntercom: "DELETE_INTERCOM",
    }),
    onRemove(id) {
      const intercom = this.intercoms.find((i) => i.id_intercom === id);
      this.$confirm(`Вы точно хотите удалить домофон "${intercom.uuid} ?"`, "Подтверждение", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        type: "warning",
      }).then(() => this.remove(id));
    },
    remove(id) {
      this.deleteIntercom(id)
        .then(() => {
          this.$message({
            message: "Домофон удален",
            type: "success",
          });
          this.$emit("intercomDeleted");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Ошибка при удалении домофона");
        });
    },
  },
};
</script>
